function getValue(object,key){return null==object?void 0:object[key]}module.exports=getValue;